<template>
    <div>
        <button type="button" data-toggle="modal" data-target="#joinTheClubModal">
            {{ btnText }}
            <svg class="arrow-right"><use xlink:href="#arrow-right-2"></use></svg>
        </button>
    </div>
</template>
<script>
export default {

    data() {
        return {
            btnText: 'Join The Club'
        }
    },

    created() {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        let cookieExists = (document.cookie.indexOf('invite') > -1 || document.cookie.indexOf('share') > -1);
        if (urlParams.has('invite') || urlParams.has('share') || cookieExists) {
            this.btnText = 'Accept Invite'
        }
    }
}
</script>
